import { Flyout } from "@amzn/stencil-react-components/flyout";
import { FlyoutContent } from "@amzn/stencil-react-components/flyout";
import React, { FC, useState } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { Order } from "../../../services/orders/orders.types";

import { HardwareOrderSupport } from "./hardware-order-support";
import { HardwareSupportOptions } from "./hardware-support-options";
import { MessageConfirmation } from "./message-confirmation";

interface HardwareSupportFlyoutProps {
  onClose: () => void;
  order?: Order;
  onMessageSent?: () => void;
}

type Step = "options" | "order" | "message";

export const HardwareSupportFlyout: FC<HardwareSupportFlyoutProps> = ({
  onClose,
  order,
  onMessageSent,
}) => {
  const [step, setStep] = useState<Step>("options");

  const showMessageConfirmation = () => {
    setStep("message");
    onMessageSent?.();
  };

  const renderStep = () => {
    switch (step) {
      case "options":
        return <HardwareSupportOptions onOrderClick={() => setStep("order")} />;
      case "order":
        return (
          <HardwareOrderSupport
            onBackClick={() => setStep("options")}
            onSendMessageClick={showMessageConfirmation}
            order={order}
          />
        );
      case "message":
        return <MessageConfirmation />;
    }
  };

  return (
    <Flyout isOpen={true} close={onClose}>
      <FlyoutContent
        titleText={getString("hardwareSupport.hardwareSupportTitle")}
        onCloseButtonClick={onClose}
        maxWidth="600px"
      >
        {renderStep()}
      </FlyoutContent>
    </Flyout>
  );
};
